import { EducatorInterface } from "../../../common/interfaces/EducatorInterface";

interface Props {
    educatorData: EducatorInterface[];
}

interface ReturnRow {
    id: number;
    columns: {
        value: string;
        onLinkClick?: () => void;
    }[];
}

export const mapEducatorDataToRows = (props: Props): ReturnRow[] => {
    const { educatorData } = props;

    return (
        educatorData.map((educator, index) => ({
            id: educator.id || index,
            columns: [
                {
                    value: educator.name,
                },
                {
                    value: educator.website_url || "Geen website",
                    ...(educator.website_url
                        ? {
                              onLinkClick: () => {
                                  window.open(educator.website_url, "_blank");
                              },
                          }
                        : {}),
                },
            ],
        })) || []
    );
};
